import Global from '../api/global';
import * as mutation from '../mutations/global';

const state = {
  now: new Date().getTime(),
  channelCardSet: [
    { name: '나라', cards: [] },
    { name: '카테고리', cards: [] },
  ],
  storeCategories: [
    { idx: 0, name: '전체' },
  ],
  communityMenu: [],
  communityNations: [],
  drawer: false,
  imageViewer: false,
  images: [],
  selectedImageIndex: 0,
  subscriptionsClicked: false,
  visitDialog: false,
  alarmDialog: false,
  time_invalids: [], // 데스크탑버전 상담신청 다이얼로그에 씀
};

const getters = {
  now: state => state.now,
  channelCardSet: state => state.channelCardSet,
  storeCategories: state => state.storeCategories,
  communityMenu: state => state.communityMenu,
  communityNations: state => state.communityNations,
  drawer: state => state.drawer,
  imageViewer: state => state.imageViewer,
  images: state => state.images,
  selectedImageIndex: state => state.selectedImageIndex,
  subscriptionsClicked: state => state.subscriptionsClicked,
  visitDialog: state => state.visitDialog,
  alarmDialog: state => state.alarmDialog,
  timeInvalid: state => state.time_invalids,
};

const actions = {
  updateNow ({ commit }) {
    setInterval(() => {
      commit(mutation.UPDATE_NOW)
    }, 60000);
  },
  selectChannelCardSet ({ commit }) {
    return Global.getChannelMenu().then(response => {
      commit(mutation.SELECT_CHANNEL_CARD_SET, response.data);
    }).catch(err => {
      console.error(err);
    });
  },
  selectStoreCategories ({ commit }) {
    return Global.getStoreNation().then(response => {
      commit(mutation.SELECT_STORE_CATEGORIES, response.data);
    }).catch(err => {
      console.error(err);
    })
  },
  selectCommunityFilters ({ commit }) {
    return Global.getCommunityCategory().then(response => {
      commit(mutation.SELECT_COMMUNITY_FILTERS, { communityMenu: response.data.menu, communityNations: response.data.nation });
    }).catch(err => {
      console.error(err);
    })
  },
  sendMail (context, form) {
    return Global.postUserSuggestion(form);
  },
  toggleImageViewer ({ commit }, { flag, images, startIndex }) {
    commit(mutation.TOGGLE_IMAGE_VIEWER, { flag, images, startIndex });
  },
  toggleDrawer ({ commit }, flag) {
    commit(mutation.TOGGLE_DRAWER, flag);
  },
  toggleVisitDialog ({ commit }, flag) {
    commit(mutation.TOGGLE_VISIT_DIALOG, flag);
  },
  toggleAlarmDialog ({ commit }, flag) {
    commit(mutation.TOGGLE_ALARM_DIALOG, flag);
  },
  selectTimeInvalid ({ commit }) {
    return Global.getTimeInvalids().then(response => {
      commit(mutation.SELECT_TIME_INVALID, response.data);
    }).catch(err => {
      console.error(err);
    });
  }
};

const mutations = {
  [mutation.UPDATE_NOW] (state) {
    state.now = new Date().getTime();
  },
  [mutation.SELECT_CHANNEL_CARD_SET] (state, cardSet) {
    state.channelCardSet[0].cards = cardSet.nations;
    state.channelCardSet[1].cards = cardSet.interests;
  },
  [mutation.SELECT_STORE_CATEGORIES] (state, categories) {
    categories.forEach(el => {
      el.name = el.name.replace(/[\r\n]+/g, '');
      state.storeCategories.push(el);
    });
  },
  [mutation.SELECT_COMMUNITY_FILTERS] (state, { communityMenu, communityNations }) {
    state.communityMenu = communityMenu;
    state.communityNations = communityNations;
  },
  [mutation.TOGGLE_IMAGE_VIEWER] (state, { flag, images, startIndex }) {
    state.images = flag ? images : [];
    state.selectedImageIndex = flag ? startIndex : 0;
    state.imageViewer = flag;
  },
  [mutation.CLICK_SUBSCRIPTION_TAB] (state) {
    state.subscriptionsClicked = true;
  },
  [mutation.TOGGLE_DRAWER] (state, flag) {
    state.drawer = flag;
  },
  [mutation.TOGGLE_VISIT_DIALOG] (state, flag) {
    state.visitDialog = flag;
  },
  [mutation.TOGGLE_ALARM_DIALOG] (state, flag) {
    state.alarmDialog = flag;
  },
  [mutation.SELECT_TIME_INVALID] (state, timeInvalids) {
    state.time_invalids = timeInvalids;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
